import { fromEvent } from 'rxjs';
import { filter, map, mergeMap, pluck } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { SET_ROLE } from '../../constants/actionTypes';
import { UIType } from '../../actions/ui/uiTypes'
import { addEntry } from '../../../lib/audit';

const windowFocus$ = (action$, state$) =>
  action$.pipe(
    ofType(SET_ROLE),
    pluck('payload'),
    filter(({role}) => role === 'PRESENTER'),
    mergeMap(() =>
      fromEvent(window, 'focus').pipe(
        map(() => { 
          addEntry('PresenterService', 'PresenterFocused', JSON.stringify({
            userId: state$.value.user.BTID,
            type: 'Focused'
          }), 'info')
          return { type: UIType.WINDOW_FOCUS }
        })
      )
    )
  );

const windowBlur$ = (action$, state$) =>
  action$.pipe(
    ofType(SET_ROLE),
    pluck('payload'),
    filter(({role}) => role === 'PRESENTER'),
    mergeMap(() =>
      fromEvent(window, 'blur').pipe(
        map(() => {
          addEntry('PresenterService', 'PresenterUnFocused', JSON.stringify({
            userId: state$.value.user.BTID,
            type: 'UnFocused'
          }), 'info')
          return { type: UIType.WINDOW_BLUR }
        })
      )
    )
  );


export { windowFocus$, windowBlur$}
